import {
  Button,
  Col,
  Descriptions,
  Input,
  Modal,
  Row,
  Space,
  Table,
} from 'antd';
import { Dropdown, InputGroup } from 'react-bootstrap';
import { useContext, useEffect, useState } from 'react';
import Axios from 'axios';
import Excel from 'components/table/excel';
import ModalDelete from 'components/tabel/ModalDelete';
import CreateCancel from 'components/forms/CreateCancel';
import CustomPagination from 'components/table/pagination';
import DashboardContext from 'Context';
import FormCategoryQuestion from './FormCategoryQuestion';

export default function CategoryQuestion() {
  const {
    SohwaddFrom,
    urldashboard,
    authentication,
    accessPage,
    handelAdd,
    handelEdit,
  } = useContext(DashboardContext);

  // table data
  const [data, setData] = useState([]);
  const [record, setRecord] = useState({});
  const [headers, setHeaders] = useState([]);
  const [loading, setLoading] = useState(false);
  const [rowId, setRowId] = useState('');
  const [totalRecord, setTotalRecord] = useState(0);
  const [searchValue, setSearchValue] = useState('');
  const [pagination, setPagination] = useState({
    page: 1,
    pageSize: 10,
  });
  // action modals
  const [moreInfoModal, setMoreInfoModal] = useState(false);
  const [deleteModal, setDeleteModal] = useState(false);

  useEffect(() => {
    if (!moreInfoModal && !deleteModal) {
      getCategoryQuestions({
        page: pagination?.page,
        pageSize: pagination?.pageSize,
        searchValue,
      });
      setRecord({});
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [handelAdd, moreInfoModal, deleteModal]);

  const getCategoryQuestions = async ({ page, pageSize, searchValue }) => {
    setLoading(true);
    try {
      let url = '/categoryQuestion/get';
      const res = await Axios.post(
        urldashboard + url,
        JSON.stringify({ page, pageSize, search: searchValue }),
        {
          headers: {
            Authorization: authentication,
            'Content-Type': 'application/json',
          },
        }
      );
      const data = await res.data;
      setHeaders(data?.headers?.map((item) => item.label));
      const items = data?.data?.map((obj) => ({ ...obj, key: obj.id }));
      setData(items);
      setTotalRecord(data?.totalRecord);
      setPagination({
        page: page,
        pageSize: pageSize,
        total: data?.totalRecord,
      });
      setLoading(false);
    } catch (error) {
      setLoading(false);
      setData([]);
    }
  };

  const handlePagination = (newPage, newPageSize) => {
    getCategoryQuestions({
      page: newPage,
      pageSize: newPageSize,
      searchValue,
    });
  };

  const search = () => {
    getCategoryQuestions({
      page: 1,
      pageSize: 10,
      searchValue,
    });
  };

  const columns = [
    {
      title: 'ردیف',
      dataIndex: 'index',
      key: 'index',
      responsive: ['xl', 'lg'],
      render: (_, record, index) => (
        <>{index + 1 + (pagination?.page - 1) * pagination?.pageSize}</>
      ),
    },
    {
      title: 'عملیات',
      key: 'actions',
      responsive: ['xl', 'lg', 'md', 'sm', 'xs'],
      render: (_, record) => (
        <Dropdown>
          <Dropdown.Toggle
            style={{ backgroundColor: '#464dee', color: '#ffffff' }}
          ></Dropdown.Toggle>

          <Dropdown.Menu id={record?.id} align={'right'}>
            {accessPage?.includes('Delete') && (
              <Dropdown.Item
                className={'d-inline-flex'}
                onClick={() => handleDelete(record?.id)}
              >
                حذف
              </Dropdown.Item>
            )}
            {accessPage?.includes('Update') && (
              <Dropdown.Item
                className={'d-inline-flex'}
                onClick={() => handleEditbtn(record?.id)}
              >
                ویرایش
              </Dropdown.Item>
            )}
          </Dropdown.Menu>
        </Dropdown>
      ),
    },
    {
      title: 'دسته',
      dataIndex: 'categoryTitle',
      key: 'categoryTitle',
      responsive: ['xl', 'lg', 'md'],
      render: (value) => <span>{value ?? '-'}</span>,
    },
    {
      title: 'سوال',
      dataIndex: 'question',
      key: 'question',
      responsive: ['xl', 'lg', 'md', 'sm', 'xs'],
      render: (value) => <span>{value ?? '-'}</span>,
    },
    {
      title: 'پاسخ',
      dataIndex: 'answer',
      key: 'answer',
      responsive: ['xl', 'lg', 'md', 'sm'],
      render: (value) => <span>{value ?? '-'}</span>,
    },
    {
      title: 'وضعیت',
      dataIndex: 'isActive',
      key: 'isActive',
      responsive: ['xl', 'lg', 'md', 'sm', 'xs'],
      render: (value) => (
        <span>
          {value ? (
            <i
              className='mdi mdi-check'
              style={{ color: 'green', fontSize: '1.5rem' }}
            ></i>
          ) : (
            <i
              className='mdi mdi-close'
              style={{ color: 'red', fontSize: '1.5rem' }}
            ></i>
          )}
        </span>
      ),
    },
    {
      title: 'اطلاعات بیشتر',
      dataIndex: 'index',
      key: 'index',
      responsive: ['xl', 'lg', 'md', 'sm', 'xs'],
      render: (_, record) => (
        <Button onClick={() => showInfoModal(record)}>
          <i className='mdi mdi-eye'></i>
        </Button>
      ),
    },
  ];

  // actions

  const showInfoModal = (data) => {
    setRecord(data);
    setMoreInfoModal(true);
  };

  const handleEditbtn = (id) => {
    handelAdd(true);
    handelEdit(id);
  };

  const handleDelete = (id) => {
    setRowId(id);
    setDeleteModal(true);
  };

  return (
    <>
      <CreateCancel />

      {SohwaddFrom ? (
        <div
          style={{
            padding: '20px',
            borderRadius: '10px',
            backgroundColor: '#ffff',
          }}
        >
          <FormCategoryQuestion />
        </div>
      ) : (
        <>
          <Row
            gutter={20}
            style={{
              marginTop: 25,
            }}
          >
            <Col xs={24} sm={24} md={24} lg={12} style={{ marginBottom: 20 }}>
              <InputGroup>
                <Input
                  placeholder='جستجوی سریع (سوال)'
                  name='searchValue'
                  onChange={(e) => setSearchValue(e.target.value)}
                  style={{
                    height: '3rem',
                    width: '90%',
                    display: 'table-cell',
                  }}
                />
                <Button
                  onClick={search}
                  style={{
                    height: '3rem',
                    width: '10%',
                    display: 'table-cell',
                    padding: 0,
                  }}
                >
                  <i className='mdi mdi-magnify'></i>
                </Button>
              </InputGroup>
            </Col>
            <Col xs={24} sm={24} md={24} lg={12} style={{ marginBottom: 20 }}>
              <Space
                wrap
                style={{
                  display: 'flex',
                  justifyContent: 'flex-end',
                  width: '100%',
                }}
              >
                <Excel
                  data={data}
                  headers={headers}
                  fileName={'سوالات_برای_گروه_اصلی_خدمات'}
                />
              </Space>
            </Col>
          </Row>

          <Table
            size='small'
            style={{ textAlign: 'right', marginTop: 10 }}
            rowClassName={() => 'center'}
            columns={columns}
            bordered={true}
            dataSource={data}
            loading={loading}
            pagination={false}
            locale={{
              emptyText: 'موردی یافت نشد',
            }}
          />

          {!loading && (
            <CustomPagination
              totalRecord={totalRecord}
              pagination={pagination}
              handlePagination={handlePagination}
            />
          )}

          {deleteModal && (
            <ModalDelete
              showitem={deleteModal}
              handleCloseMoudal={() => setDeleteModal(false)}
              handeldeleteModal={() => setDeleteModal(false)}
              id={rowId}
            />
          )}

          <Modal
            title='اطلاعات بیشتر'
            closable={false}
            open={moreInfoModal}
            onCancel={() => setMoreInfoModal(false)}
            footer={[
              <Button key='back' onClick={() => setMoreInfoModal(false)}>
                بستن
              </Button>,
            ]}
            bodyStyle={{ maxHeight: 600, overflowY: 'auto' }}
          >
            <Descriptions bordered column={1} size={'small'}>
              <Descriptions.Item label='دسته'>
                {record?.categoryTitle ?? 'اطلاعات وارد نشده'}
              </Descriptions.Item>
              <Descriptions.Item label='سوال'>
                {record?.question ?? 'اطلاعات وارد نشده'}
              </Descriptions.Item>
              <Descriptions.Item label='پاسخ'>
                {record?.answer ?? 'اطلاعات وارد نشده'}
              </Descriptions.Item>
              <Descriptions.Item label='فعال است؟'>
                {record?.isActive ? (
                  <i
                    className='mdi mdi-check'
                    style={{ color: 'green', fontSize: '1.5rem' }}
                  ></i>
                ) : (
                  <i
                    className='mdi mdi-close'
                    style={{ color: 'red', fontSize: '1.5rem' }}
                  ></i>
                )}
              </Descriptions.Item>
            </Descriptions>
          </Modal>
        </>
      )}
    </>
  );
}
